// SegmentPersonaZone, French.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Segment persona': 'Persona de segment',
  'who we want to meet · written held, because you are its author':
    'qui nous voulons rencontrer · écrite retenue, parce que vous en êtes l’auteur',
  'New segment': 'Nouveau segment',
  'loading…': 'chargement…',
  'The segments could not be read: {error}': 'Les segments n’ont pas pu être lus : {error}',
  'No segment persona yet. A segment persona is your own form — titles, seniorities, departments, sectors, cantons, topics — and is written held on the spot, because you are its author. It is what a sequence addresses and what a lookalike search is built from.':
    'Pas encore de persona de segment. Une persona de segment est votre propre formulaire — fonctions, niveaux, départements, secteurs, cantons, sujets — et elle est écrite retenue sur-le-champ, parce que vous en êtes l’auteur. C’est ce qu’une séquence adresse et ce à partir de quoi une recherche de similaires est construite.',

  'Name': 'Nom',
  'Titles': 'Fonctions',
  'Seniorities': 'Niveaux',
  'Departments': 'Départements',
  'Sectors': 'Secteurs',
  'Cantons': 'Cantons',
  'Topics': 'Sujets',
  'Directions générales du social vaudois': 'Directions générales du social vaudois',
  'Hold this segment': 'Retenir ce segment',
  'Comma-separated. A field you leave empty is not a criterion. Sectors and cantons choose which organisations of your own record the search is anchored to; topics cannot be searched on Surfe and the answer says so.':
    'Séparé par des virgules. Un champ laissé vide n’est pas un critère. Les secteurs et les cantons choisissent les organisations de votre propre dossier sur lesquelles la recherche s’ancre ; les sujets ne sont pas cherchables sur Surfe, et la réponse le dit.',
  'A segment persona needs a name.': 'Une persona de segment a besoin d’un nom.',
  'Could not write the segment persona.': 'La persona de segment n’a pas pu être écrite.',
  '{name} held as version {n}.': '{name} retenue en version {n}.',

  'version': 'version',
  'titles': 'fonctions',
  'seniorities': 'niveaux',
  'departments': 'départements',
  'sectors': 'secteurs',
  'cantons': 'cantons',
  'topics': 'sujets',

  'Find lookalikes': 'Chercher des similaires',
  'Searching…': 'Recherche…',
  'Searches Surfe for people like this segment and files each as a candidate proposal':
    'Cherche sur Surfe des personnes correspondant à ce segment et dépose chacune comme proposition de candidat',
  '{n} candidates proposed. They wait in Review; none is on the record.':
    '{n} candidats proposés. Ils attendent dans la revue ; aucun n’est au dossier.',
  'Nothing new: {known} of the answers are already on the record.':
    'Rien de nouveau : {known} des réponses sont déjà au dossier.',
  'The lookalike search failed.': 'La recherche de similaires a échoué.',
  '{proposed} proposed of {requested} asked': '{proposed} proposés sur {requested} demandés',
  '{known} already on the record': '{known} déjà au dossier',
  '{used} of {cap} today': '{used} sur {cap} aujourd’hui',
  'not searchable on Surfe: {list}': 'non cherchable sur Surfe : {list}',
  '{n} company pages asked of the scout': '{n} pages d’entreprise demandées à l’éclaireur',
  'Seniorities are Surfe’s own ten words and nothing else is accepted: {list}. Anything you write is matched to one of them or refused here, so a segment cannot be saved that no search could ever run.':
    'Les niveaux sont les dix mots propres à Surfe, et rien d’autre n’est accepté : {list}. Ce que vous écrivez est ramené à l’un d’eux ou refusé ici, afin qu’aucun segment dont la recherche ne pourrait jamais aboutir ne soit enregistré.',
  'Review the candidates': 'Examiner les candidats',
}, 'SegmentPersonaZone');
